import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';
import Icon from '../Icon';
import Image, { IImage } from '../Image';
export interface IVHSChecklistItems {
	/**
	 *  Item Label
	 */
	label: string;
}
export interface IVHSChecklistProps extends IBaseElementProps {
	/**
	 * Style
	 */
	style:  'default' | 'wide';
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Image
	 */
	image?: IImage;
	/**
	 *  Image Right
	 */
	imageRight?: string;
	/**
	 * Checklist
	 */
	list?: IVHSChecklistItems[];
	/**
	 * CTA
	 */
	cta?: ILink;
}

/**
 * Checklist
 * @block
 * @icon saved
 */
const VHSChecklist: React.FC<IVHSChecklistProps> = ({
	style,
	heading,
	image,
	imageRight,
	list = [],
	cta,
}) => (
	<div
		className={cn(
			'vhs-checklist',
			(style === 'wide') && 'vhs-checklist--wide',
		)}
	>
		<div className="vhs-checklist__container">
			<div className="vhs-checklist__wrapper">
				<div className="vhs-checklist__content">
					{heading && <h2 className="vhs-checklist__heading">{heading}</h2>}
					{list.length > 0 &&
						<ul className="vhs-checklist__list">
							{list.map(({ label }, index) =>
								<li key={index}>
									<Icon name="checkmark" />
									{label}
								</li>
							)}
						</ul>
					}
					{cta?.label && (
						<Button
							{...cta}
							className="vhs-checklist__cta"
						>
						</Button>
					)}
				</div>
				<div
					className="vhs-checklist__image-wrapper"
					style={{
						right: `${imageRight}`,
					}}
				>
					<Image
						{...image}
						className="vhs-checklist__image img-fluid"
					/>
				</div>
			</div>
		</div>
	</div>
);
export default VHSChecklist;
